/* eslint-disable perfectionist/sort-objects */
import type { Route } from 'next';

type ProfileTabs = 'experience' | 'preferences' | 'profile' | 'self-introduction' | 'work-history';

export const AppRoutes = {
	account: {
		profile: {
			index:            '/profile',
			experience:       '/profile/experience',
			personal:         '/profile/personal',
			preferences:      '/profile/preferences',
			selfIntroduction: '/profile/self-introduction',
			workHistory:      '/profile/work-history',
		},
		settings: {
			index:           '/settings',
			contactSettings: '/settings/contact-settings',
			registration:    '/settings/registration-info',
			security:        '/settings/password',
			withdrawal:      '/settings/withdrawal',
		},
	},
	auth: {
		completeProfile: '/auth/register/complete-profile',
		forgotPassword:  '/auth/forgot-password',
		login:           '/auth/login',
		register:        '/auth/register',
		resetPassword:   '/auth/reset-password',
	},
	jobs: {
		featured:      '/jobs/featured',
		new: 	         '/jobs/new',
		popular:       '/jobs/popular',
		saved:         '/jobs/saved',
		search:        '/jobs/search',
		searchResults: '/jobs/search/results',
	},
	messages: {
		list: '/messages',

		detail: (messageId: string) => `/messages/${messageId}`,
	},
	offers:    { list: '/offers' },
	companies: { popular: '/companies/popular' },
	static:    {
		contactUs:          '/contact-us',
		faq:                '/faq',
		privacyPolicy:      '/privacy-policy',
		termsAndConditions: '/terms-and-conditions',
	},
} as const;

export const getRoute = {
	profile: { index: (tab?: ProfileTabs) => (tab ? `/profile?tab=${tab}` : '/profile') as Route },
	jobs:    {
		apply:  (jobId: string) => `/jobs/${jobId}/apply`  as Route,
		detail: (jobId: string) => `/jobs/${jobId}`  as Route,
	} as const,
	offers: { detail: (offerId: string) => `/offers/${offerId}` as Route },
	static: { faqTopic: (slug: string) => `/faq/${slug}` as Route },
} as const;
